import React, {Component} from "react";
import Waypoint from "react-waypoint";

import {LargeTitle, Margin, SmallMargin} from "../Tools/Variables";
import PageContainer from "../Global/PageContainer";
import Splash from "./Splash";
import Controller2 from "./Controller2";
import Sustainability from "./Sustainability";
import StickyHeader from "./StickyHeader";
import SafeBuy from "./SafeBuy";
import Interested from "./Interested";
import Offer from "./Offer";
import InterestedModal from "../Global/InterestedModal";
import Active from "./Active";
import Sustainability2 from "./Sustainability2";
import FAQ from "./Faq";
import MailChimpModal from "../Global/MailChimpModal";

class Home extends Component {
  state = {
    location: null,
    locationHistory: null
  };
  selectLocation = activeLocation => {
    this.setState({location: activeLocation});
    this.setState({locationHistory: this.state.location});
  };
  backLocation = () => {
    this.setState({location: this.state.locationHistory});
  };

  render() {
    const Param = 1;
    return (

      <PageContainer setShowContactModal={this.props.setShowContactModal}>
        <Splash setShowContactModal={this.props.setShowContactModal}/>
        <MailChimpModal
          showContactModal={this.props.showContactModal}
          setHideContactModal={this.props.setHideContactModal}
          setShowContactModal={this.props.setShowContactModal}/>

        <StickyHeader activeLocation={this.state.location}/>

        <Margin/>
        <Waypoint onEnter={() => this.selectLocation(1)}/>
        <section id={"controllSection"}/>
        <Controller2/>
        <Waypoint onEnter={() => this.selectLocation(2)}/>
        <section id={"whySection"}/>
        <SafeBuy id={"why"}/>
        <Waypoint onEnter={() => this.selectLocation(3)} bottomOffset='200px'/>
        <section id={"susSection"}/>
        <Sustainability2/>

        <Margin/>

        <Waypoint onEnter={() => this.selectLocation(4)}/>
        <section id={"activeSection"}/>
        <Active/>
        <Margin/>
        <Waypoint onEnter={() => this.selectLocation(5)}/>
        <section id={"intrSection"}/>
        <Interested
          setShowContactModal={this.props.setShowContactModal}
          setHideContactModal={this.props.setHideContactModal}/>
        <Margin/>
        <Margin/>
        <Waypoint onEnter={() => this.selectLocation(6)}/>
        <section id={"faqSection"}/>
        <FAQ setShowContactModal={this.props.setShowContactModal} id={"FAQ"}/>
      </PageContainer>

    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js